import Vue from "vue";
import { mapGetters } from "vuex";

import { formatDateTime, stringHelper } from "@/components/mixins";

import { CartStepName } from "../Types";

export default Vue.extend({
  name: "CartStepsHeader",
  components: {},
  mixins: [formatDateTime, stringHelper],

  created() {
    return;
  },
  computed: {
    ...mapGetters(["getContentItem", "tenantDetails"]),
  },
  data: () => ({}),
  props: {
    showLeftCut: {
        type: Boolean,
        default: true
    },
    showRightArrow: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    navigateToStep(stepName: CartStepName) {
      this.$emit("on-step-change", stepName);
    },

    goToStep1() {
      this.navigateToStep(CartStepName.Step1);
    },

    goToStep2() {
      if(this.step >= 2){
        this.navigateToStep(CartStepName.Step2);
      }      
    }
  },
  watch: {},
});
